import useMutationApi from 'src/api/useMutationApi';

interface CreateWarehouseData {
  name: string;
  description?: string;
  address?: {
    street?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    country?: string;
  };
}

const useCreateWarehouse = (onSuccess?: () => void) => {
  return useMutationApi<CreateWarehouseData>({
    endpoint: 'inventory-management/warehouses',
    method: 'POST',
    options: {
      onSuccess,
    },
  });
};

export default useCreateWarehouse;
